import React, { useState, useEffect, useRef } from "react";
import NoDataFound from "../common-components/NoDataFound";
import {
  FIlterIcon,
  OverviewIcon,
  PaidIcon,
  SettingIcon,
  StarIcon,
  TrashIconForPopup,
} from "../../assets/Icon/headerCicon";
import {
  Box,
  useTheme,
  useMediaQuery,
  Button,
  TableCell,
  TableRow,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  Checkbox,
} from "@mui/material";
import InvoiceCards from "./components/InvvoiceCards";
import CustomTable from "../common-components/CustomTable";
import { SearchIcon } from "../../assets/Icon/ArrowIcon";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getDashboardData,
  getInvoiceList,
  deleteInvoice,
  sendInvoice,
  sendStripeCode,
  disconnectStripe,
  getCustomInvoices,
} from "../../stores/clients";
import CommonPagination from "../common-components/CommonPagination";
import { formatDate } from "../../utils/functions";
import { getInvoiceViewUrl } from "../../utils/fileUrl";
import CircularProgress from "@mui/material/CircularProgress";
import { OPTIONS } from "../../utils/constants";
import { setToast } from "../../stores/toast/toastslice";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import {
  ModalWrapper,
  CloseButton,
  CloseButtonWrapper,
} from "../style/modalStyle";
import { ModalTop, ModalBottom } from "../../assets/Icon/ModalIcon";
import { CrossIcon } from "../../assets/Icon/ModalIcon";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import StripeInvoiceTable from "./StripeInvoiceTable";
import CustomInvoiceTable from "./CustomInvoiceTable";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const InvoiceData = ({ setPage }: { setPage: () => void }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));

  const token = localStorage.getItem("user_token");

  const navigate = useNavigate();

  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");

  const filterRef = useRef<HTMLDivElement>(null);

  const dispatch = useDispatch();
  const { clientListStatus, total_records, error } = useSelector(
    (state: any) => state.clients
  );
  const [data, setData] = useState<any>(null);

  const searchDebounceRef = useRef<NodeJS.Timeout | null>(null);
  const [dashboardData, setDashboardData] = useState<any>(null);
  const [deleting, setDeleting] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [limit] = useState(10);
  const [searchLoading, setSearchLoading] = useState(false);
  const [paginationLoading, setPaginationLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState<string | null>(
    null
  );
  const [openMenuInvoiceId, setOpenMenuInvoiceId] = useState<string | null>(
    null
  );
  const [appliedFilterValues, setAppliedFilterValues] = useState<number[]>([]);
  const [tempFilterValues, setTempFilterValues] = useState<number[]>([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [pendingDeleteId, setPendingDeleteId] = useState<string | null>(null);
  const [disconnectAnchorEl, setDisconnectAnchorEl] =
    useState<null | HTMLElement>(null);
  const [disconnectModalOpen, setDisconnectModalOpen] = useState(false);
  const [stripeConnecting, setStripeConnecting] = useState(false);
  const [disconnectBtnLoading, setDisconnectBtnLoading] = useState(false);
  const [isStripeConnected, setIsStripeConnected] = useState(false); // Assume connected initially
  const [value, setValue] = React.useState(0);
  const [tabType, setTabType] = useState("stripe");

  const handleOpen = (
    event: React.MouseEvent<HTMLElement>,
    invoiceId: string
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedInvoiceId(invoiceId);
    setOpenMenuInvoiceId(invoiceId);
  };

  const handleClose = (option?: string) => {
    setAnchorEl(null);
    if (option && selectedInvoiceId) {
      handleOptions(option, selectedInvoiceId);
    }
    setSelectedInvoiceId(null);
    setOpenMenuInvoiceId(null);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setTabType(newValue === 1 ? "custom" : "stripe");
  };

  const handlePageChange = (newPage: number) => {
    setPageNo(newPage);
  };

  const fetchAgents = async () => {
    const offset = (pageNo - 1) * limit;
    setPaginationLoading(true);

    dispatch<any>(
      getInvoiceList({
        offset: offset,
        search: searchValue,
        filter_by: appliedFilterValues.length ? appliedFilterValues : undefined,
      })
    )
      .finally(() => {
        setPaginationLoading(false);
      })
      .then((res: any) => {
        setData(res?.payload?.data);
        if (!res?.payload?.data?.has_invoice_plan) {
          navigate("/tools/invoices");
        }
      });
  };

  useEffect(() => {
    fetchAgents();
  }, [pageNo]);

  useEffect(() => {
    // dispatch<any>(
    //   getInvoiceList({ offset: 0, search: searchValue, filter_by: filterValue })
    // );
    dispatch<any>(getDashboardData({ type: tabType })).then((result: any) => {
      if (result?.payload?.data) setDashboardData(result.payload?.data);
    });
  }, [dispatch, value]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Close filter dropdown
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target as Node)
      ) {
        setOpenFilter(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Extract data from the URL after STRIPE success
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (code) {
      setStripeConnecting(true);
      dispatch<any>(sendStripeCode({ code, state })).finally(() =>
        setStripeConnecting(false)
      );
    }
  }, [dispatch]);

  const handleOptions = (option: string, id: string) => {
    const invoice = data?.invoices?.find(
      (inv: any) => String(inv.id) === String(id)
    );
    if (option === "View") {
      if (
        invoice &&
        (invoice.invoice_status === 1 || invoice.invoice_status === 2)
      ) {
        // Open the invoice link in a new tab for Paid or Due. `invoice_pdf` is
        // an S3 key that is often null, so prefer the Stripe hosted urls.
        const invoiceUrl = getInvoiceViewUrl(invoice);
        if (!invoiceUrl) {
          dispatch<any>(
            setToast({
              message: "This invoice has no link available yet.",
              type: "error",
              title: "Error",
              onClose: () => {},
            })
          );
          return;
        }
        window.open(invoiceUrl, "_blank");
      } else {
        navigate("/tools/invoices/customerInfo", {
          state: { invoice_id: id, viewOnly: true },
        });
      }
    } else if (option === "Edit") {
      navigate("/tools/invoices/customerInfo", {
        state: { invoice_id: id, viewOnly: false },
      });
    } else if (option === "Send") {
      setSending(true);
      dispatch<any>(sendInvoice({ invoice_id: Number(id) })).then(
        (result: any) => {
          setSending(false);
          if (result?.payload?.code === 200) {
            dispatch<any>(
              setToast({
                message:
                  result?.payload?.message || "Invoice sent successfully!",
                type: "success",
                title: "Success",
                onClose: () => {},
              })
            );
          } else {
            dispatch<any>(
              setToast({
                message: result?.payload?.message || "Failed to send invoice!",
                type: "error",
                title: "Error",
                onClose: () => {},
              })
            );
          }
        }
      );
    } else if (option === "Delete") {
      setPendingDeleteId(id);
      setDeleteModalOpen(true);
    }
  };

  const handleDeleteConfirm = () => {
    if (!pendingDeleteId) return;
    setDeleting(true);
    setDeleteModalOpen(false);
    dispatch<any>(deleteInvoice(pendingDeleteId)).then((result: any) => {
      dispatch<any>(
        getInvoiceList({
          offset: 0,
          search: searchValue,
          filter_by: appliedFilterValues.length
            ? appliedFilterValues
            : undefined,
        })
      ).then(() => {
        setDeleting(false);
        if (result?.payload.code === 200) {
          dispatch<any>(
            setToast({
              message: result?.payload?.message,
              type: "success",
              title: "Success",
              onClose: () => {},
            })
          );
        } else if (result?.payload?.code === 400) {
          dispatch<any>(
            setToast({
              message: result?.payload?.message || "Failed to delete invoice!",
              type: "error",
              title: "Error",
              onClose: () => {},
            })
          );
        }
        dispatch<any>(getDashboardData({ type: tabType })).then(
          (result: any) => {
            if (result?.payload?.data) setDashboardData(result.payload?.data);
          }
        );
      });
    });
    setPendingDeleteId(null);
  };

  const handleDeleteCancel = () => {
    setDeleteModalOpen(false);
    setPendingDeleteId(null);
  };

  const handleStripeDisconnect = async () => {
    setDisconnectBtnLoading(true);
    try {
      const response = await dispatch<any>(disconnectStripe()).unwrap();
      if (response?.code === 200) {
        window.location.reload();
        dispatch<any>(
          setToast({
            message: response?.message || "Stripe account disconnected!",
            type: "success",
            title: "Success",
            onClose: () => {},
          })
        );
        dispatch<any>(
          getInvoiceList({
            offset: 0,
            search: searchValue,
            filter_by: appliedFilterValues.length
              ? appliedFilterValues
              : undefined,
          })
        );
      }
      if (response?.code === 400 || response?.code === 422) {
        dispatch<any>(
          setToast({
            message:
              response?.message || "Failed to disconnect stripe account!",
            type: "error",
            title: "Error",
            onClose: () => {},
          })
        );
      }
      setDisconnectModalOpen(false);
    } catch (e) {
      // handle error if needed
      setDisconnectModalOpen(false);
    } finally {
      setDisconnectBtnLoading(false);
    }
  };

  return (
    <div style={{ overflow: "hidden", position: "relative" }}>
      {stripeConnecting && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.7)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress size={60} thickness={5} />
        </div>
      )}
      <div
        style={{
          display: isMobile ? "grid" : "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: "8px",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            fontSize: isMobile ? "18px" : "24px",
            fontWeight: "500",
            color: "#060110",
          }}
        >
          Manage and Track Your Invoices
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 5,
            position: "relative",
            marginTop: isMobile ? 7 : 0,
          }}
        >
          {data?.account?.account_id ? (
            <div
              style={{
                background: "white",
                border: "1px solid #EAF1FA",
                width: "187px",
                height: "46px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "10px",
                position: "relative",
                gap: 5,
              }}
            >
              <CheckCircleRoundedIcon
                style={{
                  color: "#3DC826",
                  width: "20px",
                }}
              />
              <span
                style={{
                  textAlign: "center",
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#3DC826",
                }}
              >
                Stripe Connected
              </span>
            </div>
          ) : (
            <div
              style={{
                background: "white",
                border: "1px solid #EAF1FA",
                width: "187px",
                height: "46px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "10px",
                position: "relative",
                gap: 5,
              }}
            >
              {/* <CheckCircleRoundedIcon
                style={{
                  color: "#c82626ff",
                  width: "20px",
                }}
              /> */}
              <span
                style={{
                  textAlign: "center",
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#9c9797ff",
                }}
              >
                Stripe Not Connected
              </span>
            </div>
          )}
          <IconButton
            style={{
              backgroundColor: "white",
              height: "46px",
              padding: "10px",
              border: "1px solid #EAF1FA",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "background-color 0.2s",
              marginLeft: 8,
            }}
            onClick={(e) => setDisconnectAnchorEl(e.currentTarget)}
          >
            <KeyboardArrowUpIcon
              style={{
                color: "#6C6F71",
                transform: Boolean(disconnectAnchorEl)
                  ? "rotate(180deg)"
                  : "none",
                transition: "transform 0.2s",
              }}
            />
          </IconButton>
          <Menu
            anchorEl={disconnectAnchorEl}
            open={Boolean(disconnectAnchorEl)}
            onClose={() => setDisconnectAnchorEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            PaperProps={{
              sx: {
                backgroundColor: "white",
                boxShadow: "0px 5px 8px rgba(0,0,0,0.08)",
                borderRadius: "8px",
                width: "230px",
                marginTop: 1,
                marginLeft: -3,
              },
            }}
            MenuListProps={{
              disablePadding: true,
            }}
          >
            {data?.account?.account_id ? (
              <MenuItem
                onClick={() => {
                  setDisconnectAnchorEl(null);
                  setDisconnectModalOpen(true);
                }}
                disableRipple
                sx={{
                  fontWeight: 500,
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  cursor: "pointer",
                  padding: "16px 16px",
                }}
              >
                Disconnect Stripe
              </MenuItem>
            ) : (
              <MenuItem
                onClick={() => {
                  const stripeUrl = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${process.env.REACT_APP_STRIPE_CLIENT_ID}&scope=read_write&redirect_uri=${process.env.REACT_APP_STRIPE_REDIRECT_URL}&state=${token}`;

                  window.open(stripeUrl, "_blank", "noopener,noreferrer");
                }}
                disableRipple
                sx={{
                  fontWeight: 500,
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  cursor: "pointer",
                  padding: "16px 16px",
                }}
              >
                Connect to Stripe
              </MenuItem>
            )}
          </Menu>
        </div>
      </div>
      <div
        style={{ marginTop: "25px", overflow: "auto", paddingBottom: "8px" }}
      >
        {/**Cards */}
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 2 : 3,
            width: "100%",
          }}
        >
          <InvoiceCards
            title="Total Outstanding"
            price={dashboardData?.Total_outstanding_invoices?.toFixed(2) ?? 0}
            icon={<StarIcon />}
            loading={!dashboardData}
          />
          <InvoiceCards
            title="Overview"
            price={dashboardData?.Total_overview_invoices?.toFixed(2) ?? 0}
            icon={<OverviewIcon />}
            loading={!dashboardData}
          />
          <InvoiceCards
            title="Paid in Current Month"
            price={dashboardData?.Total_paid_current_month?.toFixed(2) ?? 0}
            icon={<PaidIcon />}
            loading={!dashboardData}
          />
        </Box>
      </div>
      {/**TABS */}
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            variant="scrollable"
            scrollButtons={false}
          >
            <Tab
              label="Stripe Invoice"
              {...a11yProps(0)}
              sx={{
                mx: 3,
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 600,
              }}
            />
            <Tab
              label="Custom Invoice"
              {...a11yProps(1)}
              sx={{
                mx: 3,
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 600,
              }}
            />
          </Tabs>
        </Box>

        {/**STRIPE TABLE */}
        <CustomTabPanel value={value} index={0}>
          <StripeInvoiceTable type={tabType} />
        </CustomTabPanel>

        {/**CUSTOM TABLE */}
        <CustomTabPanel value={value} index={1}>
          <CustomInvoiceTable type={tabType} />
        </CustomTabPanel>
      </Box>

      <Modal open={deleteModalOpen} onClose={handleDeleteCancel}>
        <ModalWrapper
          sx={{
            width: isMobile ? "350px" : "500px",
            p: 0,
            height: "370px",
            backgroundImage: "none",
            position: "relative",
            borderRadius: "20px",
            overflow: "hidden",
            outline: "none",
          }}
        >
          {/* Top right decoration */}
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 1,
            }}
          >
            <ModalTop />
          </div>
          {/* Bottom left decoration */}
          <div
            style={{
              position: "absolute",
              bottom: -6,
              left: 0,
              zIndex: 1,
            }}
          >
            <ModalBottom />
          </div>
          {/* Ensure close button is above decorations */}
          <CloseButtonWrapper
            sx={{ zIndex: 10, position: "relative", marginTop: 1 }}
          >
            <CloseButton onClick={handleDeleteCancel}>
              <CrossIcon />
            </CloseButton>
          </CloseButtonWrapper>
          <Box sx={{ p: 4, pt: 0 }}>
            {/* Trash icon with red bg */}
            <Box
              sx={{ display: "flex", justifyContent: "center", mt: 1, mb: 2 }}
            >
              <Box
                sx={{
                  background: "#F20F0014",
                  borderRadius: "50%",
                  p: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <TrashIconForPopup />
              </Box>
            </Box>
            <div
              style={{
                textAlign: "center",
                fontSize: isMobile ? "20px" : "24px",
                color: "#01060B",
                fontWeight: 700,
                marginTop: 0,
                marginBottom: 10,
              }}
            >
              Delete Invoice
            </div>
            <div
              style={{
                width: isMobile ? "100%" : "250px",
                textAlign: "center",
                lineHeight: "24px",
                margin: "0 auto",
                fontSize: isMobile ? "12px" : "16px",
                color: "#6C6F71",
                fontWeight: 500,
                fontFamily: "Plus Jakarta Sans",
              }}
            >
              Are you sure you want to delete this invoice?
            </div>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                mt: 3,
                justifyContent: "center",
              }}
            >
              <Button
                sx={{
                  border: "2px solid #2977CC",
                  borderRadius: "8px",
                  width: "192px",
                  height: "51px",
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#2977CC",
                }}
                onClick={handleDeleteCancel}
              >
                Close
              </Button>
              <Button
                sx={{
                  background: "linear-gradient(to right, #2977CC, #1D538F)",
                  color: "white",
                  width: "192px",
                  height: "51px",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
                onClick={handleDeleteConfirm}
              >
                Yes
              </Button>
            </Box>
          </Box>
        </ModalWrapper>
      </Modal>
      <Modal
        open={disconnectModalOpen}
        onClose={() => setDisconnectModalOpen(false)}
      >
        <ModalWrapper
          sx={{
            width: isMobile ? "350px" : "500px",
            p: 0,
            height: isMobile ? "250px" : "270px",
            backgroundImage: "none",
            position: "relative",
            borderRadius: "20px",
            overflow: "hidden",
            outline: "none",
          }}
        >
          {/* Top right decoration */}
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 1,
            }}
          >
            <ModalTop />
          </div>
          {/* Bottom left decoration */}
          <div
            style={{
              position: "absolute",
              bottom: -6,
              left: 0,
              zIndex: 1,
            }}
          >
            <ModalBottom />
          </div>
          {/* Ensure close button is above decorations */}
          <CloseButtonWrapper
            sx={{ zIndex: 10, position: "relative", marginTop: 1 }}
          >
            <CloseButton onClick={() => setDisconnectModalOpen(false)}>
              <CrossIcon />
            </CloseButton>
          </CloseButtonWrapper>
          <Box sx={{ p: 4, pt: 0 }}>
            {/* Trash icon with red bg */}
            {/* <Box
              sx={{ display: "flex", justifyContent: "center", mt: 1, mb: 2 }}
            >
              <Box
                sx={{
                  background: "#F20F0014",
                  borderRadius: "50%",
                  p: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <TrashIconForPopup />
              </Box>
            </Box> */}
            <div
              style={{
                textAlign: "center",
                fontSize: isMobile ? "20px" : "24px",
                color: "#01060B",
                fontWeight: 700,
                marginTop: 0,
                marginBottom: 10,
              }}
            >
              Disconnect Stripe
            </div>
            <div
              style={{
                width: isMobile ? "100%" : "300px",
                textAlign: "center",
                lineHeight: "24px",
                margin: "0 auto",
                fontSize: isMobile ? "12px" : "16px",
                color: "#6C6F71",
                fontWeight: 500,
                fontFamily: "Plus Jakarta Sans",
              }}
            >
              Are you sure you want to disconnect your stripe?
            </div>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                mt: 3,
                justifyContent: "center",
              }}
            >
              <Button
                sx={{
                  border: "2px solid #2977CC",
                  borderRadius: "8px",
                  width: "192px",
                  height: "51px",
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#2977CC",
                  opacity: disconnectBtnLoading ? 0.7 : 1,
                }}
                onClick={() => setDisconnectModalOpen(false)}
                disabled={disconnectBtnLoading}
              >
                Close
              </Button>
              <Button
                sx={{
                  background: disconnectBtnLoading
                    ? "#BDBDBD"
                    : "linear-gradient(to right, #2977CC, #1D538F)",
                  color: "white",
                  width: "192px",
                  height: "51px",
                  fontSize: "16px",
                  fontWeight: 600,
                  opacity: disconnectBtnLoading ? 0.7 : 1,
                }}
                onClick={handleStripeDisconnect}
                disabled={disconnectBtnLoading}
              >
                {disconnectBtnLoading ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                    }}
                  >
                    <CircularProgress size={22} sx={{ color: "#fff" }} />
                  </span>
                ) : (
                  "Yes"
                )}
              </Button>
            </Box>
          </Box>
        </ModalWrapper>
      </Modal>
    </div>
  );
};

export default InvoiceData;
